"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MawidRequest_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Appointment_1 = require("./Appointment");
var MawidRequest_Factory = /** @class */ (function () {
    function MawidRequest_Factory() {
    }
    MawidRequest_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Appointment: Appointment_1.Appointment_Factory.CreateIncoming(model.Appointment),
            AppointmentId: model.AppointmentId,
            Body: model.Body,
            ExpiredRequestDate: Date_Factory_1.Date_Factory.CreateIncoming(model.ExpiredRequestDate),
            OriginalAppointmentStatus: model.OriginalAppointmentStatus,
            OriginalAppointmentTime: model.OriginalAppointmentTime,
            OutboundRequest: model.OutboundRequest,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RetryAttempts: model.RetryAttempts,
            SuccessfulRequest: model.SuccessfulRequest,
        };
        return result;
    };
    MawidRequest_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Appointment: Appointment_1.Appointment_Factory.CreateOutgoing(model.Appointment),
            AppointmentId: model.AppointmentId,
            Body: model.Body,
            ExpiredRequestDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.ExpiredRequestDate),
            OriginalAppointmentStatus: model.OriginalAppointmentStatus,
            OriginalAppointmentTime: model.OriginalAppointmentTime,
            OutboundRequest: model.OutboundRequest,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RetryAttempts: model.RetryAttempts,
            SuccessfulRequest: model.SuccessfulRequest,
        };
        return result;
    };
    return MawidRequest_Factory;
}());
exports.MawidRequest_Factory = MawidRequest_Factory;
